import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import classNames from 'classnames';
import MenuContainer from '../containers/MenuContainer';
import ListContainer from '../containers/ListContainer';
import DetailContainer from '../containers/DetailContainer';
import ComposeViewContainer from '../containers/ComposeViewContainer';
import ToolbarContainer from '../containers/ToolbarContainer';
import Toast from 'src/ui/library/Toast';

import { MESSAGEBOX_VIEWS, MESSAGEBOX_TYPES, MESSAGEDETAIL_TYPES } from 'src/constants/constants';
import Drawer from 'src/ui/library/Drawer';
import intl from 'react-intl-universal';
export default function MessagingPres({
  currentView,
  drawerState,
  isCaseMessages,
  isDefaultOldView,
  isComposeView,
  caseId,
  contactInfo,
  detailType,
  isDraftView,
  isMobile,
  isTablet,
  showToastMessage,
  messageData,
  switchView,
  toastMessage,
  toggleDrawer,
  messageListRef,
  hideNotificationSuccess,
  selectedMenu,
  userInfo,
  setSearchMessageText,
  searchMessageText,
  history,
  enqueueSnackbar,
  trackClickAnalytics,
  inactiveCase,
}) {
  const composeClass = classNames({
    'messaging-grid-item': true,
    'messaging-list-mobile': isMobile && !isComposeView,
    detail: true,
    'mobile-height': isMobile || isTablet,
    //'desktop-height': !isMobile && !isTablet,
    'compose-case-detail-height': isCaseMessages,
  });
  const listClass = classNames({
    'messaging-grid-item': true,
    list: true,
    'messaging-list-mobile': isMobile,
    'messaging-list': !isMobile,
    'mobile-height': isMobile || isTablet,
    //'desktop-height': !isMobile && !isTablet,
    'list-case-detail-height': isCaseMessages,
  });

  const composeKey = messageData && messageData.id && !isComposeView ? messageData.id : 1;
  const style = !isCaseMessages ? null : window.screen.height === 1080 ? 'translate(0, 13%)' : 'translate(0, 23%)';

  return (
    <Fragment>
      {!isCaseMessages && isDefaultOldView && (
        <div style={{ margin: '0.5rem 0.3rem', paddingLeft: '1rem', height: '56px' }}>
          <HistoryDisplayContainer history={history} trackClickAnalytics={trackClickAnalytics} />
        </div>
      )}
      {showToastMessage && <Toast message={toastMessage} onDismiss={hideNotificationSuccess} />}

      <Grid container spacing={0} classes={{ container: 'messaging-grid' }} className={isDefaultOldView ? '' : 'messageFilterStyle'}>
        <Grid container className="documentHeader justify-space-between" direction="row">
          <Grid item className="text-left">
            <div>
              <div className="font-18 font-bold mb-10">{intl.get('messaging.pageTitle')}</div>
            </div>
          </Grid>
        </Grid>

        <Drawer
          anchor={'left'}
          isComposeView={isComposeView}
          isMobile={isMobile}
          onClose={toggleDrawer}
          open={drawerState.left.open}
          styleType="secondary">
          <Grid item lg={false} md={false} sm={12} xs={12} classes={{ item: 'messaging-grid-item' }}>
            <MenuContainer
              selectedMenu={selectedMenu}
              setSearchMessageText={setSearchMessageText}
              toggleDrawer={toggleDrawer}
              isMobile={isMobile}
              isTablet={isTablet}
            />
          </Grid>
        </Drawer>
        <Drawer
          anchor={'right'}
          isComposeView={isComposeView}
          isMobile={isMobile}
          onClose={toggleDrawer}
          open={drawerState.right.open}
          styleType="secondary"
          topFixed={true}>
          <Grid item lg={false} md={false} sm={12} xs={12} classes={{ item: composeClass }}>
            {isComposeView ? (
              <ComposeViewContainer
                userInfo={userInfo}
                isMobile={isMobile}
                toggleDrawer={toggleDrawer}
                switchView={switchView}
                caseId={caseId}
                isCaseMessages={isCaseMessages}
                contactInfo={contactInfo}
                history={history}
              />
            ) : null}
          </Grid>
        </Drawer>

        <Hidden smUp>
          {currentView === MESSAGEBOX_VIEWS.DETAILS && (
            <Grid item lg={false} md={false} sm={12} xs={12} classes={{ item: composeClass }}>
              <DetailContainer isCaseMessages={isCaseMessages} switchView={switchView} caseId={caseId} enqueueSnackbar={enqueueSnackbar} />
            </Grid>
          )}
          {currentView === MESSAGEBOX_VIEWS.LIST && (
            <Grid item lg={4} md={4} sm={9} xs={12} classes={{ item: listClass }} ref={messageListRef}>
              <ListContainer key={selectedMenu} isCaseMessages={isCaseMessages} switchView={switchView} isMobile={isMobile} />
            </Grid>
          )}
        </Hidden>
        <ToolbarContainer
          isCaseMessages={isCaseMessages}
          isComposeView={isComposeView}
          isDefaultOldView={isDefaultOldView}
          isDraftView={isDraftView}
          toggleDrawer={toggleDrawer}
          isMobile={isMobile}
          caseId={caseId}
          inactiveCase={inactiveCase}
        />
        <Grid item container className={isDefaultOldView ? '' : 'container-margin'}>
          <Grid item lg={6} md={5} sm={5}>
            <Grid container>
              <Grid item xs={12}></Grid>
              <Hidden xsDown>
                <Grid
                  item
                  md={4}
                  sm={2}
                  xs={false}
                  classes={{ item: 'messaging-grid-item' }}
                  style={{ borderRight: 'none', transform: style }}>
                  <MenuContainer selectedMenu={selectedMenu} setSearchMessageText={setSearchMessageText} />
                </Grid>
              </Hidden>

              <Grid item md={8} sm={10} xs={12} classes={{ item: listClass }} ref={messageListRef} style={{ transform: style }}>
                <ListContainer
                  key={selectedMenu}
                  isCaseMessages={isCaseMessages}
                  isDefaultOldView={isDefaultOldView}
                  setSearchMessageText={setSearchMessageText}
                  searchMessageText={searchMessageText}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} md={7} sm={7} xs={false} classes={{ item: composeClass }} style={{ transform: style }}>
            {// 1. Blocks the compose view for 0 messages in Draft menu. To show blank page in right pane.
            (selectedMenu === MESSAGEBOX_TYPES.DRAFT && isComposeView && (isDraftView || detailType === MESSAGEDETAIL_TYPES.COMPOSE)) ||
            (selectedMenu !== MESSAGEBOX_TYPES.DRAFT && isComposeView) ? (
              <div>
                <ComposeViewContainer
                  key={composeKey}
                  messageData={messageData}
                  userInfo={userInfo}
                  caseId={caseId}
                  contactInfo={contactInfo}
                  isCaseMessages={isCaseMessages}
                  history={history}
                />
              </div>
            ) : (
              <DetailContainer isCaseMessages={isCaseMessages} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

MessagingPres.propTypes = {
  isComposeView: PropTypes.bool.isRequired,
  showToastMessage: PropTypes.bool.isRequired,
  messageData: PropTypes.object,
  toastMessage: PropTypes.string.isRequired,
  hideNotificationSuccess: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  switchView: PropTypes.func.isRequired,
};
